module.exports = __webpack_public_path__ + "static/media/032-girl-5.9624c95b.svg";